import { render, staticRenderFns } from "./reflect.vue?vue&type=template&id=0bf9992e"
import script from "./reflect.vue?vue&type=script&lang=js"
export * from "./reflect.vue?vue&type=script&lang=js"
import style0 from "./reflect.vue?vue&type=style&index=0&id=0bf9992e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports